export type SmartTagSelectOption = {
  value: string;
  label: string;
};

export type SmartTagBase = {
  id: string;
  label: string;
};

export const convertSmartTagToSelectOption = (smartTag: SmartTagBase): SmartTagSelectOption => ({
  value: smartTag.id,
  label: smartTag.label,
});
